/**
 * Cleaning service — backend error code → Arabic message mapper.
 *
 * Defense-in-depth for cases where client-side validation is bypassed
 * (direct API consumers, FE drift). Stable contract is the wire `code`
 * field; raw English `error` strings stay in logs.
 *
 * Per consultant guidance: FE validates first → backend returns structured
 * AppError code → FE maps code → Arabic. Never surface raw Mongoose /
 * model-layer English to users.
 */

const ERROR_CODE_AR = {
  VAL_007: 'عدد غرف النوم مطلوب — أدخل 0 لاستوديو',
  // Defense-in-depth: PackageSelector filters by tier so this is rare in
  // normal flows, but direct API calls or bedroom-edits-mid-flow can hit it.
  PRICING_003: 'الباقة المختارة لا تطابق فئة هذا الموقع — يرجى اختيار باقة مناسبة',
  // Invoice lifecycle (INVOICE_001..006) — surfaced by InvoiceDetailPage actions
  INVOICE_001: 'الفاتورة غير موجودة',
  INVOICE_002: 'هذا الإجراء غير مسموح في الحالة الحالية للفاتورة',
  INVOICE_003: 'مبلغ الاسترداد يتجاوز إجمالي الفاتورة',
  INVOICE_004: 'تم تسجيل الدفعة لهذه الفاتورة مسبقاً',
};

export function arabicErrorFor(err, fallback = 'حدث خطأ — يرجى المحاولة مرة أخرى') {
  const code = err?.response?.data?.code;
  if (code && ERROR_CODE_AR[code]) return ERROR_CODE_AR[code];
  return err?.response?.data?.error || fallback;
}

export { ERROR_CODE_AR };
